import { memo } from 'react';

import {
  PublicShowcaseAssetHeader,
  type PublicShowcaseAssetHeaderProps,
} from '~/components/AssetModalV2/Header/PublicShowcaseAssetComponents/PublicShowcaseAssetHeader';
import { useShowcaseAssetShare } from '~/components/AssetModalV2/Header/PublicShowcaseAssetComponents/useShowcaseAssetShare';
import {
  PublicAssetModalDesktopLayout,
  type PublicAssetModalDesktopLayoutProps,
} from '~/components/AssetModalV2/PublicAssetModalDesktopLayout';

export type PublicShowcaseAssetModalDesktopLayoutProps = Pick<PublicShowcaseAssetHeaderProps, 'onCloseAssetModal'> &
  Pick<PublicAssetModalDesktopLayoutProps, 'onCloseAssetModal'>;

export const PublicShowcaseAssetModalDesktopLayout = memo(
  ({ onCloseAssetModal }: PublicShowcaseAssetModalDesktopLayoutProps) => {
    const { shareShowcaseAsset } = useShowcaseAssetShare();

    return (
      <PublicAssetModalDesktopLayout
        header={<PublicShowcaseAssetHeader onCloseAssetModal={onCloseAssetModal} />}
        onCloseAssetModal={onCloseAssetModal}
        onShare={shareShowcaseAsset}
        showFullscreenNavigationArrows={false}
      />
    );
  },
);

PublicShowcaseAssetModalDesktopLayout.displayName = 'PublicShowcaseAssetModalDesktopLayout';
